import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=5d438622&scoped=true&"
import script from "./CompanyDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=5d438622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d438622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d438622')) {
      api.createRecord('5d438622', component.options)
    } else {
      api.reload('5d438622', component.options)
    }
    module.hot.accept("./CompanyDetail.vue?vue&type=template&id=5d438622&scoped=true&", function () {
      api.rerender('5d438622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ccd/CompanyDetail.vue"
export default component.exports